import type { IconData } from '@stacksjs/iconify-core'

export const tabletCapsule: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M6.772 24.164C1.957 29.399 1.587 36.35 6.617 41.38s11.982 4.66 17.217-.155c2.361-2.171 5.284-4.964 8.857-8.536c3.572-3.573 6.365-6.495 8.536-8.857c4.816-5.235 5.185-12.187.155-17.217S29.4 1.955 24.165 6.77c-2.361 2.171-5.284 4.964-8.857 8.536c-3.572 3.573-6.365 6.496-8.536 8.857Zm8.538-8.854l17.383 17.383\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tabletCapsule
